import { render, staticRenderFns } from "./BatchPacking.vue?vue&type=template&id=a3854ba8&scoped=true"
import script from "./BatchPacking.vue?vue&type=script&lang=js"
export * from "./BatchPacking.vue?vue&type=script&lang=js"
import style0 from "./BatchPacking.vue?vue&type=style&index=0&id=a3854ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3854ba8",
  null
  
)

export default component.exports